export default "__VITE_ASSET__1f7e70b0__"